import React from "react";
import "./NewsCard.css";

function NewsCard({ news }) {
  return (
    <div className="card">
      <img src="https://via.placeholder.com/300" alt="news" />
      <h3>{news.title}</h3>
      <p>{news.desc}</p>
    </div>
  );
}

export default NewsCard;